import utils from '@/js/utils'

const spacersMuFactor = 1.2

export default {
  get(spacers) {
    let numOfSpacers = 0
    for (let s of spacers) {
      if (!s.qty || !s.l || !s.material) return false
      // find number of spacers
      numOfSpacers += parseInt(s.qty)
    }
    let mu = numOfSpacers * spacersMuFactor

    return utils.toFixedNumber(mu, 2)
  }
}
